<template>
  <svg
    class="arrow-circle-button"
    width="92"
    height="92"
    viewBox="0 0 92 92"
    fill="none"
    @mouseover="hover = true"
    @mouseleave="hover = false">
    <g
      opacity="0.9"
      filter="url(#filter0_d_2515_1092)">
      <circle
        cx="46"
        cy="46"
        r="36"
        transform="rotate(-90 46 46)"
        :fill="`url(#${id})`" />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M65.1201 46.7403L65 46L65.1201 45.2597C58.1014 44.1213 53.2659 41.5167 50.1892 38.2453C47.1153 34.9769 45.75 30.9942 45.75 27H44.25C44.25 31.3472 45.7418 35.706 49.0965 39.273C51.4259 41.7497 54.6305 43.8211 58.8079 45.25L27 45.25V46.75L58.8079 46.75C54.6305 48.1789 51.4259 50.2503 49.0965 52.727C45.7418 56.294 44.25 60.6528 44.25 65H45.75C45.75 61.0058 47.1153 57.0231 50.1892 53.7547C53.2658 50.4833 58.1014 47.8787 65.1201 46.7403Z"
      fill="black" />
    <defs>
      <filter
        id="filter0_d_2515_1092"
        x="0"
        y="0"
        width="92"
        height="92"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset />
        <feGaussianBlur stdDeviation="5" />
        <feComposite
          in2="hardAlpha"
          operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.219608 0 0 0 0 0.172549 0 0 0 0 0.458824 0 0 0 0.1 0" />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2515_1092" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2515_1092"
          result="shape" />
      </filter>
      <linearGradient
        :id="id"
        x1="10"
        y1="46"
        x2="82"
        y2="46"
        gradientUnits="userSpaceOnUse">
        <stop :stop-color="hover ? '#99B4FF' : '#F3F0ED'" />
        <stop
          offset="1"
          :stop-color="hover ? '#6FCFD7' : '#F3F0ED'" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup>
import { ref } from 'vue'
import useUtils from '@/composables/useUtils'

const { genUUID } = useUtils()

const id = `${genUUID()}-arrow-circle-button`
const props = defineProps(['hover'])

const hover = ref(props.hover)
</script>

<style lang="scss">
.arrow-circle-button {
  @apply cursor-pointer;
}
</style>
